// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3d18828f","239":"52a1aa04","455":"8d7aa5c6"}[chunkId] + ".chunk.js";
};